export enum FlowDecorationColor {
  Yellow = 'Yellow',
  Purple = 'Purple',
  Green = 'Green',
  Blue = 'Blue',
  Pink = 'Pink',
  Orange = 'Orange',
}
